function Hero({ content }) {
  return (
    <section className="hero">
      <img
        className="hero-background"
        src={content.image}
        alt={content.imageAlt}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-6">
            <div className="hero-content" data-wow="fade-right">
              <h1>
                {content.title}
              </h1>
              <p className="hero-copy">{content.description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
